var render = function () {
  var _vm$currentRound, _vm$currentRound$cont, _vm$currentRound$cont2, _vm$currentRound2, _vm$currentRound2$con;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    staticClass: "fancy-formatting-container",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('aside', {
    staticClass: "fancy-image"
  }, [_c('figure', [_c('img', {
    attrs: {
      "alt": (_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : (_vm$currentRound$cont = _vm$currentRound.contentImage) === null || _vm$currentRound$cont === void 0 ? void 0 : _vm$currentRound$cont.image.description,
      "src": (_vm$currentRound$cont2 = (_vm$currentRound2 = _vm.currentRound) === null || _vm$currentRound2 === void 0 ? void 0 : (_vm$currentRound2$con = _vm$currentRound2.contentImage) === null || _vm$currentRound2$con === void 0 ? void 0 : _vm$currentRound2$con.image.src) !== null && _vm$currentRound$cont2 !== void 0 ? _vm$currentRound$cont2 : ''
    }
  })])]), _c('section', {
    staticClass: "fancy-formatting-instructions-container",
    class: {
      isMobile: _vm.isMobile
    }
  }, [_c('span', {
    staticClass: "round-instructions"
  }, [_vm._v(_vm._s(_vm.currentRound.instructions))]), _c('div', {
    staticClass: "format-section"
  }, [_c('div', {
    staticClass: "format-section-background",
    style: _vm.svgElements.buttonsContainer
  }, [_c('div', {
    staticClass: "format-buttons-container"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Text Formatting Tools")])]), _c('div', {
    staticClass: "format-buttons"
  }, [_c('TextFormattingButtons', {
    attrs: {
      "options": _vm.optionsTextFormattingButtons
    }
  }, [_c('li', [_c('button', {
    staticClass: "solve-all-button pure-button",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.handleSolveAll
    }
  }, [_c('span', [_vm._v("Solve All")])])])])], 1)])])]), _c('text-display-list', {
    staticClass: "format-text-display",
    attrs: {
      "text-size": "smaller"
    }
  }, [_c('li', {
    staticClass: "typing-section",
    class: {
      selectable: _vm.typingDone
    },
    on: {
      "mouseup": _vm.setFirstSelectedWordElement,
      "touchend": _vm.setFirstSelectedWordElement
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentStep.answer,
      "text-step": 0,
      "text-selectable-after-typing": true
    }
  })], 1)])], 1)])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }